import {
  initialState,
  Actions,
  State,
  GET_STATICS_PREJUDICIAL,
  GET_STATICS_PREJUDICIAL_SUCCESS,
  GET_STATICS_PREJUDICIAL_ERROR,
  RESET_GET_STATICS_PREJUDICIAL,
} from "../../types/prejudicial/statics";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_STATICS_PREJUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_STATICS_PREJUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_STATICS_PREJUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_STATICS_PREJUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
